import Http from '../utils/http'

export const getAll = (params = {}) => Http.get(`/calendar`, { params })



// WEBPACK FOOTER //
// ./src/services/calendar.js